import { wgApiClient } from 'wg-api-sdk';

import { authMiddleware } from './authMiddleware';

export const baseUrl = import.meta.env.DEV
  ? '/'
  : import.meta.env.VITE_API_HOST;

const wgApi = wgApiClient({
  baseUrl,
});

wgApi.use(authMiddleware);

export default wgApi;
